import React from "react";
import { Modal, Form, Input, Button } from "antd";

const EmailModal = ({ isModalOpen, setIsModalOpen, handleConnect }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      handleConnect({ ...values, type: isModalOpen });
      form.resetFields();
      setIsModalOpen(null);
    } catch (errorInfo) {}
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(null);
  };

  return (
    <Modal
      title={
        <div
          className="heading24px text-color-1C1C1C roboto-medium"
          style={{ padding: "20px 24px 10px" }}
        >
          Enter Email
        </div>
      }
      open={!!isModalOpen}
      onCancel={handleCancel}
      centered
      className="delete-popup"
      width={400}
      footer={
        <div className="d-flex justify-content-end gap-20 mx-2">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" className="theme-btn mb20" onClick={handleOk}>
            Connect
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        layout="vertical"
        style={{ padding: "24px 24px 0 24px" }}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please input your email!" },
            { type: "email", message: "Enter a valid email address!" },
          ]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailModal;
